export const GET_GRADEWISE_COMMENTS = 'GET_GRADEWISE_COMMENTS'
export const SAVE_GRADEWISE_COMMENTS = 'SAVE_GRADEWISE_COMMENTS'
